var Sprite = require('./sprite');
var globalSprite = new Sprite();

if (document.body) {
  globalSprite.elem = globalSprite.render(document.body);
} else {
  document.addEventListener('DOMContentLoaded', function () {
    globalSprite.elem = globalSprite.render(document.body);
  }, false);
}

module.exports = globalSprite;



//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/web/global-sprite.js
// module id = 45
// module chunks = 0